import { Button } from '@plato/ui-legacy/components/ui/button';
import { Check, NotebookPen } from 'lucide-react';
import type { MouseEvent, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    isLogged: boolean;
    disabled?: boolean;
    onClick: (e: MouseEvent<HTMLButtonElement>) => void;
};

export function EventLogButton({ isLogged, disabled, onClick }: Props): ReactNode {
    const { t } = useTranslation('events');

    return (
        <div className="w-full flex justify-end">
            <Button
                disabled={disabled}
                variant={isLogged ? 'ghost' : 'secondary'}
                icon={isLogged ? Check : NotebookPen}
                onClick={onClick}
                className={isLogged ? 'text-green-600' : undefined}
            >
                {isLogged ? t('card_log_button_logged') : t('card_log_button')}
            </Button>
        </div>
    );
}
